import React from "react";
import { Card, CardContent } from "@/components/ui/card";
import { Wifi } from "lucide-react";
import { useIPValidation } from "@/hooks/useIPValidation";

interface IPValidationGuardProps {
  children: React.ReactNode;
  allowedIPRanges: string | null;
}

export const IPValidationGuard = React.memo(
  ({ children, allowedIPRanges }: IPValidationGuardProps) => {
    const { isValidIP, clientIP, isChecking } =
      useIPValidation(allowedIPRanges);

    if (isChecking) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-gray-50">
          <Card className="w-full max-w-md">
            <CardContent className="pt-6">
              <div className="text-center space-y-4">
                <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto"></div>
                <h3 className="text-lg font-semibold">Checking IP Access</h3>
                <p className="text-gray-600">Please wait...</p>
              </div>
            </CardContent>
          </Card>
        </div>
      );
    }

    if (isValidIP === false) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-gray-50">
          <Card className="w-full max-w-md">
            <CardContent className="pt-6">
              <div className="text-center space-y-4">
                <Wifi className="h-12 w-12 text-red-500 mx-auto" />
                <h3 className="text-lg font-semibold text-red-600">
                  Access Restricted
                </h3>
                <p className="text-gray-600">
                  Your IP address ({clientIP}) is not authorized to access this
                  assessment. Please contact your administrator.
                </p>
              </div>
            </CardContent>
          </Card>
        </div>
      );
    }

    return <>{children}</>;
  }
);

IPValidationGuard.displayName = "IPValidationGuard";
